import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "min-w-0"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_3 = {
  class: "truncate text-sm font-semibold text-slate-900"
};
const _hoisted_4 = {
  class: "status-badge is-neutral"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  class: "data-table-scroll"
};
const _hoisted_7 = {
  class: "data-table text-sm"
};
const _hoisted_8 = {
  class: "data-table-head"
};
const _hoisted_9 = {
  class: "data-table-th is-center w-20"
};
const _hoisted_10 = {
  class: "flex items-center justify-center gap-2"
};
const _hoisted_11 = {
  class: "inline-flex cursor-pointer items-center justify-center"
};
const _hoisted_12 = ["checked", "disabled"];
const _hoisted_13 = {
  class: "data-table-body"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  class: "data-table-td is-center"
};
const _hoisted_16 = ["value", "checked", "disabled", "aria-label", "onChange"];
const _hoisted_17 = {
  class: "data-table-td"
};
const _hoisted_18 = {
  class: "data-table-cell-title"
};
const _hoisted_19 = {
  class: "data-table-cell-meta"
};
const _hoisted_20 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_21 = {
  class: "data-table-td is-right font-medium text-slate-900"
};
const _hoisted_22 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_23 = {
  class: "data-table-td is-right"
};
const _hoisted_24 = {
  class: "data-table-td"
};
const _hoisted_25 = {
  class: "status-badge is-info"
};
const _hoisted_26 = {
  class: "data-table-td is-center"
};
const _hoisted_27 = {
  class: "flex items-center justify-center gap-1.5"
};
const _hoisted_28 = ["disabled", "onClick"];
const _hoisted_29 = ["disabled", "onClick"];
import { computed } from 'vue';
import { PencilSquareIcon, PlusIcon, TrashIcon } from '@heroicons/vue/24/outline';
import { formatProfitRate, formatWanAmount } from '../utils';
export default {
  __name: 'InvoiceCustomerPanel',
  props: {
    region: {
      type: Object,
      required: true
    },
    customers: {
      type: Array,
      default: () => []
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    syncing: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:selectedIds', 'create-customer', 'edit-customer', 'delete-customer'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const embedded = computed(() => props.embedded);
    const panelClass = computed(() => props.embedded ? 'bg-white' : 'rounded-lg border border-slate-200 bg-white');
    const headerClass = computed(() => ['flex flex-wrap items-center justify-between gap-3 px-4 py-3', props.embedded ? 'border-b border-slate-100' : 'border-b border-slate-200']);
    const currentCustomerIds = computed(() => props.customers.map(customer => customer.id).filter(id => id !== null && id !== undefined));
    const allCurrentSelected = computed(() => currentCustomerIds.value.length > 0 && currentCustomerIds.value.every(id => isSelected(id)));
    function isSelected(customerId) {
      return props.selectedIds.some(id => String(id) === String(customerId));
    }
    function toggleCustomer(customerId, checked) {
      const nextIds = props.selectedIds.filter(id => String(id) !== String(customerId));
      if (checked) {
        nextIds.push(customerId);
      }
      emit('update:selectedIds', nextIds);
    }
    function toggleCurrentRegion(checked) {
      const currentIdSet = new Set(currentCustomerIds.value.map(id => String(id)));
      const nextIds = props.selectedIds.filter(id => !currentIdSet.has(String(id)));
      if (checked) {
        nextIds.push(...currentCustomerIds.value);
      }
      emit('update:selectedIds', nextIds);
    }
    function displayCompanyName(customer) {
      return customer.companyName || customer.customerName || customer.name || '-';
    }
    function firstDefined(customer, keys) {
      for (const key of keys) {
        if (customer[key] !== null && customer[key] !== undefined && customer[key] !== '') {
          return customer[key];
        }
      }
      return null;
    }
    function amountRange(customer) {
      const minAmount = firstDefined(customer, ['minTargetOutputAmount', 'targetOutputAmountMin', 'minAllowedAmount', 'allowedMinAmount', 'amountLowerLimit', 'lowerAmountLimit']);
      const maxAmount = firstDefined(customer, ['maxTargetOutputAmount', 'targetOutputAmountMax', 'maxAllowedAmount', 'allowedMaxAmount', 'amountUpperLimit', 'upperAmountLimit']);
      if (minAmount === null && maxAmount === null) return '-';
      if (minAmount !== null && maxAmount !== null) return formatWanAmount(minAmount) + ' 至 ' + formatWanAmount(maxAmount);
      if (minAmount !== null) return '不低于 ' + formatWanAmount(minAmount);
      return '不高于 ' + formatWanAmount(maxAmount);
    }
    function splitHint(customer) {
      const amount = Number(customer.targetOutputAmount || 0);
      if (amount < 500000) return '允许 1 笔';
      if (amount < 1000000) return '建议 2 笔';
      if (amount < 3000000) return '至少 2 笔';
      return '建议 3 笔以上';
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", {
        class: _normalizeClass(panelClass.value)
      }, [_createElementVNode("header", {
        class: _normalizeClass(headerClass.value)
      }, [!embedded.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h4", _hoisted_3, _toDisplayString(__props.region.regionName || '未命名区域'), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(__props.customers.length) + " 个客户", 1)]), _cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "mt-1 text-xs text-slate-500"
      }, "客户 ID 使用当月名单客户 ID 选择", -1))])) : _createCommentVNode("", true), _createElementVNode("button", {
        type: "button",
        class: "btn-primary inline-flex items-center gap-1.5",
        disabled: __props.syncing,
        onClick: _cache[0] || (_cache[0] = $event => emit('create-customer', __props.region))
      }, [_createVNode(_unref(PlusIcon), {
        class: "h-4 w-4"
      }), _cache[3] || (_cache[3] = _createTextVNode(" 新增客户 ", -1))], 8, _hoisted_5)], 2), _createElementVNode("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_createElementVNode("thead", _hoisted_8, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "选择", -1)), _createElementVNode("label", _hoisted_11, [_createElementVNode("input", {
        type: "checkbox",
        class: "form-check",
        checked: allCurrentSelected.value,
        disabled: __props.syncing || __props.customers.length === 0,
        "aria-label": "选择当前区域全部客户",
        onChange: _cache[1] || (_cache[1] = $event => toggleCurrentRegion($event.target.checked))
      }, null, 40, _hoisted_12)])])]), _cache[5] || (_cache[5] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "公司", -1)), _cache[6] || (_cache[6] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "注册地", -1)), _cache[7] || (_cache[7] = _createElementVNode("th", {
        class: "data-table-th is-right"
      }, "目标额度", -1)), _cache[8] || (_cache[8] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "允许范围", -1)), _cache[9] || (_cache[9] = _createElementVNode("th", {
        class: "data-table-th is-right"
      }, "利润率", -1)), _cache[10] || (_cache[10] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "拆分提示", -1)), _cache[11] || (_cache[11] = _createElementVNode("th", {
        class: "data-table-th is-center w-28"
      }, "操作", -1))])]), _createElementVNode("tbody", _hoisted_13, [__props.customers.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[12] || (_cache[12] = [_createElementVNode("td", {
        colspan: "8",
        class: "data-table-empty is-compact"
      }, "暂无客户", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(__props.customers, customer => {
        return _openBlock(), _createElementBlock("tr", {
          key: customer.id,
          class: "data-table-row"
        }, [_createElementVNode("td", _hoisted_15, [_createElementVNode("input", {
          type: "checkbox",
          class: "form-check",
          value: customer.id,
          checked: isSelected(customer.id),
          disabled: __props.syncing,
          "aria-label": '选择客户 ' + displayCompanyName(customer),
          onChange: $event => toggleCustomer(customer.id, $event.target.checked)
        }, null, 40, _hoisted_16)]), _createElementVNode("td", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(displayCompanyName(customer)), 1), _createElementVNode("div", _hoisted_19, "名单客户 ID：" + _toDisplayString(customer.id || '-'), 1)]), _createElementVNode("td", _hoisted_20, _toDisplayString(customer.registeredRegion || '-'), 1), _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(formatWanAmount)(customer.targetOutputAmount)), 1), _createElementVNode("td", _hoisted_22, _toDisplayString(amountRange(customer)), 1), _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatProfitRate)(customer.targetProfitRate)), 1), _createElementVNode("td", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(splitHint(customer)), 1)]), _createElementVNode("td", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("button", {
          type: "button",
          class: "table-action-button is-primary",
          title: "编辑客户",
          "aria-label": "编辑客户",
          disabled: __props.syncing,
          onClick: $event => emit('edit-customer', customer)
        }, [_createVNode(_unref(PencilSquareIcon), {
          class: "h-4 w-4"
        })], 8, _hoisted_28), _createElementVNode("button", {
          type: "button",
          class: "table-action-button is-danger",
          title: "删除客户",
          "aria-label": "删除客户",
          disabled: __props.syncing,
          onClick: $event => emit('delete-customer', customer)
        }, [_createVNode(_unref(TrashIcon), {
          class: "h-4 w-4"
        })], 8, _hoisted_29)])])]);
      }), 128))])])])], 2);
    };
  }
};